var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38908 0C3.76454 0 2.01788e-06 3.61992 0 8.06678C-2.88269e-06 15.8913 7.91613 21.8399 7.91613 21.8399C8.05127 21.9435 8.21901 22 8.39189 22C8.56477 22 8.73252 21.9435 8.86765 21.8399C8.86765 21.8399 16.7838 15.8913 16.7838 8.06678C16.7838 3.61992 13.0136 0 8.38908 0ZM8.38908 1.46718C12.1892 1.46718 15.258 4.41264 15.258 8.06678C15.258 14.4679 9.2301 19.5253 8.39471 20.2103C7.5633 19.5287 1.5258 14.4704 1.5258 8.06678C1.5258 4.41264 4.58894 1.46718 8.38908 1.46718Z",
    fill: "#E4151B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38888 4.16211C6.16747 4.16211 4.35133 5.8993 4.35132 8.02412C4.3513 10.149 6.16746 11.8918 8.38888 11.8918C10.6103 11.8918 12.4324 10.149 12.4324 8.02412C12.4324 5.8993 10.6103 4.16211 8.38888 4.16211ZM8.38888 5.70806C9.73703 5.70806 10.8162 6.73458 10.8162 8.02412C10.8162 9.31366 9.73704 10.3459 8.38888 10.3459C7.04071 10.3459 5.96753 9.31366 5.96753 8.02412C5.96754 6.73458 7.04072 5.70806 8.38888 5.70806Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRedIcon);
export default __webpack_public_path__ + "static/media/location-red-icon.be47b7994b846c41123139a0440a318f.svg";
export { ForwardRef as ReactComponent };